// RDS Instance Class lookup
export const getInstanceSpecs = (instanceClass: string) => {
  const specs: Record<string, { cpu: string; memory: string }> = {
    // T4g instances (Graviton2)
    "db.t4g.micro": { cpu: "2 vCPUs", memory: "1 GB" },
    "db.t4g.small": { cpu: "2 vCPUs", memory: "2 GB" },
    "db.t4g.medium": { cpu: "2 vCPUs", memory: "4 GB" },
    "db.t4g.large": { cpu: "2 vCPUs", memory: "8 GB" },
    "db.t4g.xlarge": { cpu: "4 vCPUs", memory: "16 GB" },
    "db.t4g.2xlarge": { cpu: "8 vCPUs", memory: "32 GB" },
    // T3 instances
    "db.t3.micro": { cpu: "2 vCPUs", memory: "1 GB" },
    "db.t3.small": { cpu: "2 vCPUs", memory: "2 GB" },
    "db.t3.medium": { cpu: "2 vCPUs", memory: "4 GB" },
    "db.t3.large": { cpu: "2 vCPUs", memory: "8 GB" },
    "db.t3.xlarge": { cpu: "4 vCPUs", memory: "16 GB" },
    "db.t3.2xlarge": { cpu: "8 vCPUs", memory: "32 GB" },
    // M6g instances (Graviton2)
    "db.m6g.large": { cpu: "2 vCPUs", memory: "8 GB" },
    "db.m6g.xlarge": { cpu: "4 vCPUs", memory: "16 GB" },
    "db.m6g.2xlarge": { cpu: "8 vCPUs", memory: "32 GB" },
    "db.m6g.4xlarge": { cpu: "16 vCPUs", memory: "64 GB" },
    "db.m6g.8xlarge": { cpu: "32 vCPUs", memory: "128 GB" },
    "db.m6g.12xlarge": { cpu: "48 vCPUs", memory: "192 GB" },
    "db.m6g.16xlarge": { cpu: "64 vCPUs", memory: "256 GB" },
    // M5 instances
    "db.m5.large": { cpu: "2 vCPUs", memory: "8 GB" },
    "db.m5.xlarge": { cpu: "4 vCPUs", memory: "16 GB" },
    "db.m5.2xlarge": { cpu: "8 vCPUs", memory: "32 GB" },
    "db.m5.4xlarge": { cpu: "16 vCPUs", memory: "64 GB" },
    "db.m5.8xlarge": { cpu: "32 vCPUs", memory: "128 GB" },
    "db.m5.12xlarge": { cpu: "48 vCPUs", memory: "192 GB" },
    "db.m5.16xlarge": { cpu: "64 vCPUs", memory: "256 GB" },
    "db.m5.24xlarge": { cpu: "96 vCPUs", memory: "384 GB" },
    // R6g instances (Graviton2, memory optimized)
    "db.r6g.large": { cpu: "2 vCPUs", memory: "16 GB" },
    "db.r6g.xlarge": { cpu: "4 vCPUs", memory: "32 GB" },
    "db.r6g.2xlarge": { cpu: "8 vCPUs", memory: "64 GB" },
    "db.r6g.4xlarge": { cpu: "16 vCPUs", memory: "128 GB" },
    "db.r6g.8xlarge": { cpu: "32 vCPUs", memory: "256 GB" },
    "db.r6g.12xlarge": { cpu: "48 vCPUs", memory: "384 GB" },
    "db.r6g.16xlarge": { cpu: "64 vCPUs", memory: "512 GB" },
    // R5 instances (memory optimized)
    "db.r5.large": { cpu: "2 vCPUs", memory: "16 GB" },
    "db.r5.xlarge": { cpu: "4 vCPUs", memory: "32 GB" },
    "db.r5.2xlarge": { cpu: "8 vCPUs", memory: "64 GB" },
    "db.r5.4xlarge": { cpu: "16 vCPUs", memory: "128 GB" },
    "db.r5.8xlarge": { cpu: "32 vCPUs", memory: "256 GB" },
    "db.r5.12xlarge": { cpu: "48 vCPUs", memory: "384 GB" },
    "db.r5.16xlarge": { cpu: "64 vCPUs", memory: "512 GB" },
    "db.r5.24xlarge": { cpu: "96 vCPUs", memory: "768 GB" },
  };
  return specs[instanceClass] || { cpu: "Unknown", memory: "Unknown" };
};

// Storage Type IOPS lookup
export const getStorageIops = (
  storageType: string,
  allocatedStorage?: number,
) => {
  const type = storageType?.toLowerCase();
  switch (type) {
    case "gp2":
      // GP2: 3 IOPS per GB, min 100, max 16,000
      if (allocatedStorage) {
        const iops = Math.min(Math.max(allocatedStorage * 3, 100), 16000);
        return `${iops}`;
      }
      return "3/GB";
    case "gp3":
      // GP3: Baseline 3,000 IOPS (can be provisioned up to 16,000)
      return "3,000 (baseline)";
    case "io1":
      return "Provisioned";
    case "io2":
      return "Provisioned";
    case "magnetic":
      return "~100";
    default:
      return "Unknown";
  }
};

// Encryption algorithm
export const getEncryptionAlgorithm = (encrypted: boolean) => {
  if (!encrypted) {
    return "None";
  }
  // AWS RDS uses AES-256 encryption for all encrypted databases
  return "AES-256";
};
